import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../../context";
import { Rating } from "./Rating";
export const ProductCard = ({ product }) => {
    const { cartList, addToCart, removeFromCart } = useCart();
    const [inCart, setInCart] = useState(false);
    const { id, name, overview, poster, price, rating, bestSeller, inStock } = product;

    useEffect(() => {
        const productInCart = cartList.find(item => item.id === product.id);

        if (productInCart) {
            setInCart(true);
        } else {
            setInCart(false);
        }
    }, [cartList, product.id]);

    return (
        <div className="m-3 max-w-sm bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700 flex flex-col transform transition-transform hover:scale-105 hover:shadow-lg duration-300 relative">
            <Link to={`/products/${id}`} className="relative">
                {bestSeller && (
                    <span className="absolute top-4 left-2 px-2 bg-orange-500 bg-opacity-90 text-white rounded z-10">
                        Best Seller
                    </span>
                )}
                <img className="rounded-t-lg w-full h-64 object-cover transition-opacity duration-300 hover:opacity-90" src={poster} alt={name} />
            </Link>
            <div className="p-5 flex flex-col flex-grow">
                <Link to={`/products/${id}`}>
                    <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white transition-colors duration-300 hover:text-blue-600">{name}</h5>
                </Link>
                <p className="mb-3 font-normal text-gray-700 dark:text-gray-400 flex-grow">{overview}</p>
                <div className="flex justify-between items-center mt-auto">
                    <div className="flex items-center">
                        <Rating rating={rating} />
                    </div>
                    {!inCart ? (
                        <button 
                            onClick={() => addToCart(product)} 
                            className={`inline-flex items-center py-2 px-3 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition-colors duration-300 ${inStock ? "" : "cursor-not-allowed"}`} 
                            disabled={!inStock}
                        >
                            Add To Cart <i className="ml-1 bi bi-plus-lg"></i>
                        </button>
                    ) : (
                        <button 
                            onClick={() => removeFromCart(product)} 
                            className={`inline-flex items-center py-2 px-3 text-sm font-medium text-center text-white bg-red-600 rounded-lg hover:bg-red-800 transition-colors duration-300 ${inStock ? "" : "cursor-not-allowed"}`} 
                            disabled={!inStock}
                        >
                            Remove Item <i className="ml-1 bi bi-trash3"></i>
                        </button>
                    )}
                </div>
                <p className="text-2xl dark:text-gray-200 mt-2">
                    <span>$</span><span>{price}</span>
                </p>
            </div>
        </div>
    );
}
